export const TOKEN_KEY = '@smartcon-token';
export const DOMAIN = '@domain';
export const isAuthenticated = () => sessionStorage.getItem(TOKEN_KEY) !== null;
export const getToken = () => sessionStorage.getItem(TOKEN_KEY);
export const login = (token) => sessionStorage.setItem(TOKEN_KEY, token);
export const logOut = () => sessionStorage.removeItem(TOKEN_KEY);
export const clearAuth = () => sessionStorage.clear();
export const domainSchool = (domain) => sessionStorage.setItem(DOMAIN, domain);
export const getDomain = () => sessionStorage.getItem(DOMAIN);
